"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTitleFromParams = exports.getSearchParams = exports.default = exports.cssAnchorName = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preact = require("preact");

var _utils = require("./utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * FormPrefiller is a headless component that reads URL search parameters
 * and prefills the topic creation form with values.
 * It handles dynamically rendered fields by observing DOM changes.
 *
 * IMPORTANT INTERACTIONS:
 * 1. This component only prefills fields once - it tracks which fields have been
 *    filled in the prefilledFields Set and won't attempt to refill them.
 * 2. This prevents conflicts with user edits - once a user modifies a field,
 *    the component won't override their changes, even if new DOM elements are added.
 * 3. The component works alongside Marionette's CreateTopicWysiwyg without conflicts
 *    because it only sets initial values, not ongoing state management.
 */
var cssAnchorName = 'form-prefiller';
/**
 * Safely gets URL search parameters, handling SSR environments
 */

exports.cssAnchorName = cssAnchorName;

var getSearchParams = function getSearchParams() {
  try {
    return new URLSearchParams(window.location.search);
  } catch (error) {
    return new URLSearchParams();
  }
};
/**
 * Gets the title value from URL parameters
 * Exported for use in other components like SearchBox
 * @returns The title value or empty string if not found
 */


exports.getSearchParams = getSearchParams;

var getTitleFromParams = function getTitleFromParams() {
  var _params$get$trim, _params$get;

  var params = getSearchParams();
  return (_params$get$trim = (_params$get = params.get('title')) === null || _params$get === void 0 ? void 0 : _params$get.trim()) !== null && _params$get$trim !== void 0 ? _params$get$trim : '';
};

exports.getTitleFromParams = getTitleFromParams;

var FormPrefiller = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FormPrefiller, _Component);

  var _super = _createSuper(FormPrefiller);

  function FormPrefiller() {
    var _this;

    (0, _classCallCheck2.default)(this, FormPrefiller);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "prefilledFields", new Set());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "observer", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setupFieldObserver", function () {
      if (typeof MutationObserver === 'undefined' || typeof document === 'undefined') {
        return;
      }

      _this.observer = new MutationObserver(function (mutations) {
        // Check if any of the fields we're interested in were added
        var shouldCheck = false;
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList' && mutation.addedNodes.length) {
            shouldCheck = true;
          }
        });

        if (shouldCheck) {
          _this.prefillAvailableFields();
        }
      }); // Start observing the form or the entire document body if form isn't found yet

      var form = document.querySelector('form[name="topic"]');

      _this.observer.observe(form !== null && form !== void 0 ? form : document.body, {
        childList: true,
        subtree: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "prefillAvailableFields", function () {
      var params = getSearchParams(); // Handle type field

      if (!_this.prefilledFields.has('type') && params.has('type')) {
        var _params$get2;

        var typeValue = (_params$get2 = params.get('type')) === null || _params$get2 === void 0 ? void 0 : _params$get2.trim();

        if (typeValue) {
          var radioId = (0, _utils.mapTopicTypeToRadioId)(typeValue);

          if (radioId && (0, _utils.checkRadioButton)(radioId)) {
            _this.prefilledFields.add('type');
          }
        }
      }
    });
    return _this;
  }

  (0, _createClass2.default)(FormPrefiller, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // add keyboard accessibility for radio buttons
      (0, _utils.setupRadioGroupKeyboardAccess)();

      if (typeof window === 'undefined' || !getSearchParams().toString()) {
        return;
      } // Immediately try to prefill fields that might already be in the DOM


      this.prefillAvailableFields(); // Set up observer to watch for dynamically added fields

      this.setupFieldObserver();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Clean up observer when component unmounts
      if (this.observer) {
        this.observer.disconnect();
      }
    }
    /**
     * Sets up a MutationObserver to watch for fields being added to the DOM
     */

  }, {
    key: "render",
    value: // eslint-disable-next-line class-methods-use-this
    function render() {
      // This is a headless component, so it doesn't render anything
      return null;
    }
  }]);
  return FormPrefiller;
}(_preact.Component);

exports.default = FormPrefiller;